import { isFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18597
// Отображение квоты Почты у экстерналов
export const externalMailQuota: boolean = isFeature('ph-external-mail-quota') ?? false;
